export default {
  temporaryLedgerLabelContainer: {}, // needs to be defined, overridden by parent prop
  inputStyle: {
    paddingTop: '22px',
  },
  label: {
    position: 'static',
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: 700,
    color: '#484B50',
    letterSpacing: '2px',
    transform: 'translate(0, 1.5px)',
  },
};
